import Acl from "./acl";

const checkPermissions = function (element, customPemission = null) {
  if(element.submenu) {
      element.submenu = element.submenu.map( (i) => checkPermissions(i, customPemission)).filter( e => e != null);
      return (element.submenu.length == 0) ? null : element;
  }
  
  if(element.permission && Acl.can(element.permission, null, customPemission)) {
      return element;
  }
  return null;
}

export default checkPermissions
